export const isEmpty = (listOfInputs) => {
    let valueIsEmpty = false;
    if (listOfInputs?.length > 0) {
        listOfInputs.map((input) => {
            if (input === null || input === undefined || input === "") {
                valueIsEmpty = true;
                return valueIsEmpty;
            }
        });
    }

    return valueIsEmpty;
};
